import { Box as MuiBox, Dialog, DialogContent, Divider as MuiDivider, Typography } from "@material-ui/core"
import { spacing } from "@material-ui/system";
import { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { GradientButton } from "./PropertyForm";
import { FeedbackMap } from "./controllers/index"
import { useTranslation } from "react-i18next";

const Divider = styled(MuiDivider)(spacing);
const Box = styled(MuiBox)(spacing);
export const FeedbackModal = (p: {
    onOpenModal: (fn: () => void) => void
    feedbackMap?: FeedbackMap
}) => {
    const { feedbackMap } = p;
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const onOpenModal = () => {
        setOpen(true);
    }
    useEffect(() => {
        p.onOpenModal(onOpenModal)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const closeModal = () => {
        setOpen(false)
    }
    const imgUrl = feedbackMap?.img ? feedbackMap?.img : process.env.PUBLIC_URL + "/static/img/brands/demo_image.jpg"
    return <Dialog
        open={open}
        fullWidth
        maxWidth="md"
        onClose={closeModal}
    >
        <DialogContent>
            <Typography variant="h4">
                {feedbackMap?.q_title}
            </Typography>
            <Divider my={2} />
            <Box my={2} style={{
                backgroundImage: `url(${imgUrl})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                width: "100%",
                height: "400px"
            }}>
            </Box>
            <Box mt={6} mb={4} style={{
                display: "grid",
                placeItems: "center"
            }}>
                <GradientButton style={{
                    width: "20%"
                }} onClick={closeModal}>
                    {t("generalWords_Close")}
                </GradientButton>
            </Box>
            {/* <Typography variant="subtitle1" color="textSecondary">
                Some Content
            </Typography>
            <Box style={{
                width: "100%",
                background: "#2b3b4b",
                padding: "10px",
                borderRadius: "3px",
            }}>
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
                Very long text information
            </Box> */}
        </DialogContent>
    </Dialog>
}